import type { RouteRecordRaw } from 'vue-router'

export const reportsRoutes: RouteRecordRaw[] = [
  {
    path: '/reports/administrative/automations',
    name: 'reports-administrative-automations',
    component: () => import('./administrative/automations/pages/AutomationLogsPage.vue')
  },
  {
    path: '/reports/voice/call-history',
    name: 'reports-voice-call-history',
    component: () => import('./voice/call-history/pages/CallHistoryPage.vue')
  },
  {
    path: '/reports/voice/call-history/:id',
    name: 'reports-voice-call-history-show',
    component: () => import('./voice/call-history/pages/CallHistoryShowPage.vue')
  },
  {
    path: '/reports/voice/ivr-analysis',
    name: 'reports-voice-ivr-analysis',
    component: () => import('./voice/ivr-analysis/pages/IvrAnalysisPage.vue')
  },
  {
    path: '/reports/voice/missed-calls',
    name: 'reports-voice-missed-calls',
    component: () => import('./voice/missed-calls/pages/MissedCallsPage.vue')
  },
  {
    path: '/reports/voice/extension-analysis',
    name: 'reports-voice-extension-analysis',
    component: () => import('./voice/extension-analysis/pages/ExtensionAnalysisPage.vue')
  },
  {
    path: '/reports/voice/inbound-analysis',
    name: 'reports-voice-inbound-analysis',
    component: () => import('./voice/inbound-analysis/pages/InboundAnalysisPage.vue')
  },
  {
    path: '/reports/voice/call-queue-analysis',
    name: 'reports-voice-call-queue-analysis',
    component: () => import('./voice/call-queue-analysis/pages/CallQueueAnalysisPage.vue')
  },
  {
    path: '/reports/voice/call-queue-analysis/:callQueueId',
    name: 'reports-voice-call-queue-analysis-queue',
    component: () => import('./voice/call-queue-analysis/pages/CallQueueAnalysisQueuePage.vue'),
    props: true
  },
  {
    path: '/reports/email-logs',
    name: 'reports-email-logs',
    component: () => import('./email-logs/pages/EmailLogsPage.vue')
  },
  {
    path: '/reports/message-logs',
    name: 'reports-message-logs',
    component: () => import('./message-logs/pages/MessageLogsPage.vue')
  }
]
